export abstract class GameObject {
    abstract update(): void
    abstract draw(): void
}
